'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listItemStrategy = function listItemStrategy(change, data) {
  var firstBlock = change.value.startBlock;
  if (firstBlock) {
    var itemBlock = change.value.document.getClosestBlock(firstBlock.key);
    if (itemBlock && itemBlock.type === 'list_item') {
      return change.setNodeByKey(itemBlock.key, { data: data });
    }
  }
  return change;
};

var ListItemButton = function ListItemButton(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      value = _ref.value,
      onChange = _ref.onChange,
      data = _ref.data;

  return _react2.default.createElement(_ToolbarButton2.default, {
    icon: icon,
    text: title,
    title: title,
    onMouseDown: function onMouseDown() {
      return onChange(listItemStrategy(value.change(), data));
    }
  });
};

ListItemButton.propTypes = {
  icon: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  data: _propTypes2.default.object.isRequired
};

exports.default = ListItemButton;